import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState, AppActionCreators } from '../store';

const SAFARI_AUTH_TOKEN_KEY = 'safari_auth_token';
const SAFARI_AUTH_REFRESH_TOKEN_KEY = 'safari_auth_refreshToken';
const SAFARI_AUTH_USER_KEY = 'safari_auth_user';

export const useSafariAuthPersistence = () => {
  const dispatch = useDispatch();
  const token = useSelector((state: ApplicationState) => state.app?.token);
  const refreshToken = useSelector((state: ApplicationState) => state.app?.refreshToken);
  const user = useSelector((state: ApplicationState) => state.app?.appUser);

  useEffect(() => {
    if (token) {
      sessionStorage.setItem(SAFARI_AUTH_TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(SAFARI_AUTH_TOKEN_KEY);
    }

    if (refreshToken) {
      sessionStorage.setItem(SAFARI_AUTH_REFRESH_TOKEN_KEY, refreshToken);
    } else {
      sessionStorage.removeItem(SAFARI_AUTH_REFRESH_TOKEN_KEY);
    }

    if (user) {
      sessionStorage.setItem(SAFARI_AUTH_USER_KEY, JSON.stringify(user));
    } else {
      sessionStorage.removeItem(SAFARI_AUTH_USER_KEY);
    }
  }, [token, refreshToken, user]);

  useEffect(() => {
    const storedToken = sessionStorage.getItem(SAFARI_AUTH_TOKEN_KEY);
    const storedRefreshToken = sessionStorage.getItem(SAFARI_AUTH_REFRESH_TOKEN_KEY);

    if (storedToken && !token) {
      (dispatch as any)(AppActionCreators.SetToken(storedToken));
    }

    if (storedRefreshToken && !refreshToken) {
      (dispatch as any)(AppActionCreators.SetRefreshToken(storedRefreshToken));
    }
  }, [dispatch, token, refreshToken]);
};

export default useSafariAuthPersistence;
